export class Society {
	id: number;
    name: string;
    order: number;
    
    constructor(){}
}